.wrapper {
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: var(--padding-small);
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  opacity: 0;
  
  &.fullWidth {
    width: 100% !important;
  }
  
  &.isOpen {
    
  }

  &.lightBackground {
    background: rgba(255, 255, 255, 0.5);
  }

  &.absolute {
    position: absolute;
  }

  &.rounded {
    border-radius: var(--border-radius-large);
  }
  &.isPanel {
    /*border-left: 1px solid #eee;
    height: auto;
    margin-left: calc(var(--spacing)* -3);
    width: calc(100% +(var(--spacing)* 6));
    padding:0;
    justify-content: space-between;
    position: static;
    left:auto;
    right: 0;*/
  }
}

.container {
  position: relative;
  width: 100%;
  padding: 0;
  background: #f5f5f5;
  border-radius: 14px;
  overflow: hidden;

  &.hasCloseButton {
    padding-top: 0px;
  }

  @media (--md) {
    max-width: 343px;
    &.isPanel {
      /*max-width: none;*/
    }
  }
  &.isPanel {
    /*box-shadow: inset 0 7px 9px -7px rgba(0,0,0,0.7), inset 0 -7px 9px -7px rgba(0,0,0,0.7);
    padding-bottom:10px;
    width: calc(100% + 20px);
    border-radius: 0;*/
  }
}

.lightBackground .container {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}
